import { render, staticRenderFns } from "./MarketSegmentRadioFormPart.vue?vue&type=template&id=50eddc45"
import script from "./MarketSegmentRadioFormPart.vue?vue&type=script&lang=js"
export * from "./MarketSegmentRadioFormPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports